import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { MemberTypeEnum } from '~/enums';
import { useAppSelector } from '~/hooks/useAppSelector';
import { useCreatePublicInvite } from '~/hooks/useCreatePublicInvite';
import { UploadComposeSettingsImages } from '~/pages/Authenticated/AddOrgMember/components/Form/types';
import { InviteMemberService } from '~/services/resources/inviteMember';
import { addMemberActions } from '~/store/slices/addMember';
import { InviteMemberDTO } from '~/types/interfaces/invite-member';

export const useAddMemberController = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();

  const { organizationSelectedId } = useAppSelector(({ auth }) => auth);
  const { ecosystemsToShare, userConfigurations, composeSettings } =
    useAppSelector(({ addMember }) => addMember);

  const { handleCreatePublicInvite, isSubmittingPublicInvite } =
    useCreatePublicInvite(MemberTypeEnum.Member);

  const handleInviteMember = async ({
    backgroundImage,
    logo,
  }: UploadComposeSettingsImages) => {
    try {
      if (!organizationSelectedId || !composeSettings) return;
      setIsSubmitting(true);
      const data: InviteMemberDTO = {
        userConfigurations,
        ecosystemsData: ecosystemsToShare,
        sharerOrganization: organizationSelectedId,
        composeSettings: {
          ...composeSettings,
          logo,
          backgroundImage,
        },
      };
      await InviteMemberService.createInvite(data);
      toast.success('Member(s) invited successfully.');
      dispatch(addMemberActions.reset());
    } catch (error) {
      toast.error('Error on trying to invite private member(s).');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    dispatch(addMemberActions.reset());
  }, [dispatch]);

  return {
    handleInviteMember,
    isSubmitting,
    isSubmittingPublicInvite,
    handleCreatePublicInvite,
  };
};
